<template>
  <div class="a-rms-pvp-evolution-tooltip">
    <v-tooltip
      content-class="tooltip-shadow pvp-evolution-tooltip-content"
      color="white"
      :open-delay="400"
      :close-delay="0"
      transition="none"
      right
    >
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" x-small class="cursor-pointer">
          mdi-information-slab-circle-outline
        </v-icon>
      </template>
      <span
        class="text-center justify-center align-center pvp-evolution-tooltip"
      >
        <v-data-table
          :headers="headers"
          :items="items"
          :item-class="getDatatableRowClass"
          hide-default-footer
          disable-pagination
          dense
        >
          <template v-slot:[`item.commit_date`]="{ item }">
            <span class="text-caption">{{ formatDate(item.commit_date) }}</span>
          </template>
          <template v-slot:[`item.commit_time`]="{ item }">
            <span class="text-caption">{{ item.commit_time }}</span>
          </template>
          <template v-slot:[`item.pvp`]="{ item }">
            <span class="text-caption font-weight-bold">
              <a-kpi
                kpi="pvp"
                :value="item.pvp"
                :vs_values="[item.pvp - item.diff]"
                :vs_periods="['previous_price']"
                :absolute="true"
                x_small
                hide_icon
                iconRight
                show_plus_sign
              />
            </span>
          </template>
          <template v-slot:[`item.user`]="{ item }">
            <span class="text-caption">{{ item.user }}</span>
          </template>
        </v-data-table>
      </span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapState } from "vuex";
import aKpi from "@/components/rms_ui/aKpi.vue";

export default {
  name: "a-rms-pvp-evolution-tooltip",
  components: {
    aKpi
  },
  props: {
    date: {
      type: String,
      mandatory: true
    }
  },
  computed: {
    headers() {
      return [
        {
          align: "start",
          sortable: false,
          value: "commit_date",
          text: this.$t("date")
        },
        {
          align: "center",
          sortable: false,
          value: "commit_time",
          text: this.$t("hour")
        },
        {
          align: "center",
          sortable: false,
          value: "pvp",
          text: this.$t("price_dense")
        },
        {
          align: "start",
          sortable: false,
          value: "user",
          text: this.$t("user")
        }
      ];
    },
    items() {
      return this.pvp_evolution_daily && this.pvp_evolution_daily[this.date]
        ? this.pvp_evolution_daily[this.date]
        : [];
    },
    ...mapState({
      pvp_evolution_daily: state => state.rms.pvp_evolution_daily
    })
  },
  methods: {
    formatPrice(price) {
      // Convierte el precio a número eliminando decimales
      const numPrice = parseFloat(price.toString().replace(",", "."));
      return Math.round(numPrice).toString();
    },
    formatDate(date) {
      // Convierte de YYYY-MM-DD a DD/MM/YYYY
      if (!date) return "";
      const parts = date.split("-");
      if (parts.length !== 3) return date;
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    },
    getDatatableRowClass() {
      return "a-datatable-row";
    }
  }
};
</script>

<style lang="scss">
.pvp-evolution-tooltip-content {
  .v-data-table {
    .v-data-table__wrapper {
      overflow: hidden;
      th {
        padding: 0 !important;
        font-size: 10px !important;
        .v-icon {
          font-size: 12px !important;
        }
      }
      .a-datatable-row {
        td {
          padding: 0 4px !important;
          height: auto !important;
          width: auto !important;
          .currency-symbol {
            margin-left: -3px;
            font-size: 10px !important;
          }
        }
      }
    }
  }
}
</style>
